import { Helmet } from '@dr.pogodin/react-helmet'
import React from 'react'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { AllLocales } from '../locale/Locale'

interface Props {
  title: string
  description: string
  path: string
}

export const Seo: React.FC<Props> = ({ title, description, path }) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const locale = useSessionLanguage()
  const canonical = origin + '/' + locale + '/' + path

  const lang = useSessionLanguage()

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <link rel='canonical' href={canonical} />
      <link rel='alternate' hrefLang={'it'} href={`${origin}/it/${path}`} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content='website' />
      <meta property='twitter:title' content={title} />
      <meta property='twitter:description' content={description} />
      {AllLocales.map((lang) => (
        <link key={lang} rel='alternate' hrefLang={lang} href={`${origin}/${lang}/${path}`} />
      ))}
      <meta name='description' content={description} />
    </Helmet>
  )
}
